import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const RegistrationPrompt = ({ isLoading = false }) => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="mt-8 pt-6 border-t border-border text-center">
      <p className="text-sm text-muted-foreground mb-4">
        Don't have an account yet?
      </p>
      <Button
        variant="outline"
        size="lg"
        fullWidth
        onClick={handleRegisterClick}
        disabled={isLoading}
      >
        Create New Account
      </Button>
      <p className="text-xs text-muted-foreground mt-3">
        Join thousands of event-goers and discover amazing experiences
      </p>
    </div>
  );
};

export default RegistrationPrompt;